/**
 * @enum {string}
 * Ditap alert button type.
 */
const AlertButtonType = {
  /**
   * @type {string}
   * @constant
   */
  OKANDCANCEL: "OKANDCANCEL",
  /**
   * @type {string}
   * @constant
   */
  ONLYOK: "ONLYOK",
  /**
   * @type {string}
   * @constant
   */
  NOBUTTONS: "NOBUTTONS",
};

export default Object.freeze(AlertButtonType);
